import { DELETED_MEMBER_MODAL_CLEAR } from './types';

export function clearDeletedMemberData() {
  return {
    type: DELETED_MEMBER_MODAL_CLEAR,
  };
}
